import { createSlice } from '@reduxjs/toolkit';
import { Actividades, Ruta_Sesion } from 'generated/graphql';

const initialState: Ruta_Sesion[] = [];

const numeroEvaluacionesSesionSlice = createSlice({
	name: 'numeroEvaluacionesSesionState',
	initialState,
	reducers: {
		setNumeroEvaluacionesSesion: (state, action) => {
			return action.payload;
		},
		resetNumeroEvaluacionesSesion: () => {
			return initialState;
		}
	}
});

export const { setNumeroEvaluacionesSesion, resetNumeroEvaluacionesSesion } = numeroEvaluacionesSesionSlice.actions;
export default numeroEvaluacionesSesionSlice.reducer;
